<div class="showBg" style="padding: 20px;">
  <div class="register-container d-flex justify-content-center align-items-center py-4">
    <div class="register-card card p-3 shadow">
      <div class="text-center marginShow bigTitleCol">{{ 'REGISTER.TITLE' | translate }}</div>

      <form #registrationForm="ngForm" (ngSubmit)="onRegister(registrationForm)" class="formText">

        <div class="marginShow">
          <label for="regSchoolName" class="form-label">{{ 'REGISTER.SCHOOL_NAME_LABEL' | translate }}</label>
          <input type="text" class="form-control form-control-sm" id="regSchoolName" name="regSchoolName"
                 [(ngModel)]="registerData.name"
                 [placeholder]="'REGISTER.SCHOOL_NAME_PLACEHOLDER' | translate"
                 required #nameInput="ngModel"
                 [disabled]="isLoading || isNameDisabled">
          <div *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)" class="text-danger mt-1 small">
            <div *ngIf="nameInput.errors?.['required']">{{ 'VALIDATION.SCHOOL_NAME_REQUIRED' | translate }}</div>
          </div>
        </div>

        <!-- <div class="marginShow">
          <label for="regSchoolAddress" class="form-label">{{ 'REGISTER.SCHOOL_ADDRESS_LABEL' | translate }}</label>
          <input type="text" class="form-control form-control-sm" id="regSchoolAddress" name="regSchoolAddress"
                 [(ngModel)]="registerData.address"
                 [placeholder]="'REGISTER.SCHOOL_ADDRESS_PLACEHOLDER' | translate"
                 required #addressInput="ngModel"
                 [disabled]="isLoading">
          <div *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)" class="text-danger mt-1 small">
            <div *ngIf="addressInput.errors?.['required']">{{ 'VALIDATION.SCHOOL_ADDRESS_REQUIRED' | translate }}</div>
          </div>
        </div> -->

        <div class="marginShow">
          <label for="regEmail" class="form-label">{{ 'REGISTER.EMAIL_LABEL' | translate }}</label>
          <input type="email" class="form-control form-control-sm" id="regEmail" name="regEmail"
                 [(ngModel)]="registerData.email"
                 [placeholder]="'REGISTER.EMAIL_PLACEHOLDER' | translate"
                 required email #emailInput="ngModel"
                 [disabled]="isLoading || isEmailDisabled">
          <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger mt-1 small">
            <div *ngIf="emailInput.errors?.['required']">{{ 'VALIDATION.EMAIL_REQUIRED' | translate }}</div>
            <div *ngIf="emailInput.errors?.['email']">{{ 'VALIDATION.EMAIL_INVALID' | translate }}</div>
          </div>
        </div>

        <div class="marginShow">
          <label for="regPassword" class="form-label">{{ 'REGISTER.PASSWORD_LABEL' | translate }}</label>
          <input [type]="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="regPassword" name="regPassword"
                 [(ngModel)]="registerData.password"
                 [placeholder]="'REGISTER.PASSWORD_PLACEHOLDER' | translate"
                 required minlength="6" #passwordInput="ngModel"
                 [disabled]="isLoading">
          <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)" class="text-danger mt-1 small">
            <div *ngIf="passwordInput.errors?.['required']">{{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}</div>
            <div *ngIf="passwordInput.errors?.['minlength']">{{ 'VALIDATION.PASSWORD_MINLENGTH' | translate }}</div>
          </div>
        </div>
        <div class="marginShow form-check">
          <input type="checkbox" class="form-check-input" id="regShowPasswordCheck" (change)="toggleShowPassword()" [disabled]="isLoading">
          <label class="form-check-label" for="regShowPasswordCheck">{{ 'REGISTER.SHOW_PASSWORD' | translate }}</label>
        </div>

        <div class="marginShow">
          <label for="confirmPassword" class="form-label">{{ 'REGISTER.CONFIRM_PASSWORD_LABEL' | translate }}</label>
          <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control form-control-sm" id="confirmPassword" name="confirmPassword"
                 [(ngModel)]="registerData.confirmPassword"
                 [placeholder]="'REGISTER.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                 required #confirmPasswordInput="ngModel"
                 [disabled]="isLoading">
          <div *ngIf="confirmPasswordInput.invalid && (confirmPasswordInput.dirty || confirmPasswordInput.touched) && confirmPasswordInput.errors?.['required']" class="text-danger mt-1 small">
            {{ 'VALIDATION.CONFIRM_PASSWORD_REQUIRED' | translate }}
          </div>
           </div>
        <div class="marginShow form-check">
          <input type="checkbox" class="form-check-input" id="regShowConfirmPasswordCheck" (change)="toggleShowConfirmPassword()" [disabled]="isLoading">
          <label class="form-check-label" for="regShowConfirmPasswordCheck">{{ 'REGISTER.SHOW_PASSWORD' | translate }}</label>
        </div>

        <div *ngIf="registrationError && !isLoading" class="alert alert-danger small p-2">
          {{ registrationError }} </div>
        <div *ngIf="registrationSuccess && !isLoading" class="alert alert-success small p-2">
          {{ registrationSuccess | translate }} </div>

        <!-- <button type="submit" class="btn button-primary-purple w-100 btn-sm" [disabled]="registrationForm.invalid || isLoading">
          <span *ngIf="isLoading; else registerButtonText">
            {{ 'REGISTER.REGISTERING_BUTTON' | translate }} <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <ng-template #registerButtonText>{{ 'REGISTER.CONFIRM_BUTTON' | translate }}</ng-template>
        </button> -->
        <button type="submit" class="btn button-primary-purple w-100 btn-sm">
          <span *ngIf="isLoading; else registerButtonText">
            {{ 'REGISTER.REGISTERING_BUTTON' | translate }} <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <ng-template #registerButtonText>{{ 'REGISTER.CONFIRM_BUTTON' | translate }}</ng-template>
        </button>
      </form>

      <div class="text-center mt-3 " style="font-size: 0.775em;">
        <p>{{ 'REGISTER.LOGIN_HERE_PROMPT' | translate }}
          <span  style="text-decoration: underline"><a routerLink="/login" [class.disabled-link]="isLoading">{{ 'REGISTER.LOGIN_HERE_LINK' | translate }}</a></span> </p>
      </div>
    </div>
  </div>
</div>